import { AiOutlinePlusSquare } from "react-icons/ai";
import { BsSliders } from "react-icons/bs";
import { LuSearch, LuPlusSquare, LuMinusSquare } from "react-icons/lu";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { getRates } from "../../../api/rate";
import AddRate from "../../modals/AddRate";
import CryptoTable from "./CryptoTable";
import DeleteRateModal from "../../modals/DeleteRateModal";
import { usePermissionEffect } from "../../../utils/usePermissionEffect";

export default function CryptoRate() {
  const boxShadowStyle = {
    boxShadow: "0px 2px 9px 0px #00000008",
    userSelect: "none",
  };

  const [open, setOpen] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [giftData, setData] = useState(null);
  const [indexToHide, setIndexToHide] = useState([]);
  const [allData, setAllData] = useState([]);
  const [search, setSearch] = useState("");
  const { getModulePermission } = usePermissionEffect();

  const { data } = useQuery("crypto", () => getRates("crypto"));

  useEffect(() => {
    if (data) {
      setAllData(data);
    }
  }, [data]);

  const onSearch = (e) => {
    setSearch(e.target.value);
    if (!e.target.value) {
      setAllData(data);
    } else {
      setAllData((prev) =>
        prev.filter((d) => {
          console.log({ d: d?._id, v: e.target.value });
          return d._id?.toLowerCase().includes(e.target.value?.toLowerCase());
        }),
      );
    }
  };

  return (
    <>
      {/*<AddGiftcardRates />*/}
      <div className="bg-white w-full rounded-lg p-4 space-y-2 font-Neurial">
        <div className="flex justify-between items-center">
          <div className="text-[#7B7B7B] text-[16px]">
            Set and adjust Crypto buy rates
          </div>
          <div className="flex items-center gap-3">
            <div
              className="border-[1px] border-[#E9EFF4] bg-white rounded-lg p-2 cursor-pointer"
              title={`Search`}
              style={boxShadowStyle}
            >
              <div className="text-[14px] text-[#A0A3BD] leading-5 flex items-center gap-2 w-full h-full relative">
                <LuSearch className="text-[18px]" />
                <input
                  value={search}
                  onChange={onSearch}
                  className="w-[200px] placeholder:text-[#A0A3BD] text-[13px] outline-none text-black bg-transparent"
                  placeholder=" Type to Search"
                />
              </div>
            </div>
            {getModulePermission("rate", "canCreate") && (
              <div
                className="bg-[#2121F11A] p-2 rounded-[5px] cursor-pointer"
                title="Add new rate"
                onClick={() => setOpen(true)}
              >
                <div className="text-[#2121F1] font-bold text-[15px] font-Neurial flex items-center gap-1">
                  <AiOutlinePlusSquare />
                  <span>Add rates</span>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="w-full">
          <table className="table-auto w-full border-collapse border-[1px] border-[#E8E8E8]">
            <thead className="bg-[#F7F7F7] text-[14px] font-dmsans text-[#787389] font-medium">
              <tr className="">
                <th className="py-3 pl-4"></th>
                <th className="py-3 px-2 text-start w-full">Crypto</th>
              </tr>
            </thead>
          </table>
          <table className="table-auto w-full border-collapse border-[1px] border-[#E8E8E8] !rounded-none">
            <tbody className="text-[#787389] font-Neurial text-[15px]">
              {(allData || []).map((cryp, index) => (
                <>
                  <div className="flex gap-4  p-5">
                    {indexToHide.includes(index) ? (
                      <LuMinusSquare
                        onClick={() =>
                          setIndexToHide((prev) =>
                            prev.filter((p) => p !== index),
                          )
                        }
                      />
                    ) : (
                      <LuPlusSquare
                        onClick={() =>
                          setIndexToHide((prev) => [...prev, index])
                        }
                      />
                    )}

                    <p className=" text-[#1B0A4B] capitalize font-bold -mt-1">
                      {cryp._id} ({cryp.record.length})
                    </p>
                  </div>
                  {indexToHide.includes(index) && (
                    <div className="p-5">
                      <CryptoTable
                        setData={setData}
                        setOpen={setOpen}
                        data={cryp.record}
                        setOpenDeleteModal={setOpenDeleteModal}
                        getModulePermission={getModulePermission}
                      />
                    </div>
                  )}
                </>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <DeleteRateModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        data={giftData}
        type="crypto"
      />
      <AddRate
        open={open}
        setOpen={setOpen}
        data={giftData}
        type="crypto"
        allRates={data || []}
      />
    </>
  );
}
